import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel and track PageView
    initMetaPixel('1013515225182190');
  }, []);
  return <LandingPage data-id="element-0" />;
}